module.exports = __webpack_public_path__ + "ea96d42cea984232504bd069323aab4e.jpg";